export default __webpack_public_path__ + "static/media/uau.8765ea94.gif";